module.exports = __webpack_public_path__ + "img/car-nosignal.73784d02.svg";